<template>
    <div id="recently">
        <el-scrollbar class="write_scrollbar">
            <div class="page_wraper">
                <div class="page_banner">
                    <div class="banner_text">
                        <h1 class="title_text">懒人办公，写作神器<img class="fast_speed" src="./img/img_icon_23.png" alt=""></h1>
                        <div class="slogin_text">全自动Ai文章写作，放空您的大脑和双手！</div>
                        <div class="desc_text">集Ai写作、改写润色、扩写简写、自动配图等功能为一体的全自动Ai写作生成器</div>
                        <div class="banner_btns clearfix">
                            <div class="banner_btn" @click="showVideo"><img class="btn_icon" src="./img/img_icon_25.png" />一分钟了解我们</div>
                            <router-link class="banner_btn" to="/essaywriting?tplid=19"><img class="btn_icon" src="./img/img_icon_67.png" />开始创作</router-link>
                        </div>
                    </div>
                    <div class="banner_right">
                        <img class="banner_img" src="./img/img_icon_24.png" alt="">
                    </div>
                </div>
                <div class="page_part">
                    <div class="part_header no_border"><img class="title_icon" src="./img/img_icon_27.png" alt="">快速访问</div>
                    <div class="part_content">
                        <el-row class="fast_list" :gutter="20">
                            <el-col :span="48">
                                <router-link to="/essaywriting" class="list_item">
                                    <img class="item_icon" src="./img/img_icon_28.png" alt="">
                                    <div class="item_right">
                                        <div class="item_title">新建文档</div>
                                        <div class="item_desc">从空白文本开始起草</div>
                                    </div>
                                </router-link>
                            </el-col>
                            <el-col :span="48">
                                <div class="list_item" @click="showUpload">
                                    <img class="item_icon" src="./img/img_icon_29.png" alt="">
                                    <div class="item_right">
                                        <div class="item_title">上传Word文档</div>
                                        <div class="item_desc">从本地上传文档开始</div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="48" v-for="doc in fast_list" :key="doc.id">
                                <div class="list_item">
                                    <img class="item_icon" :src="doc.app_icon" alt="" @click="openDetail(doc)">
                                    <div class="item_right" @click="openDetail(doc)">
                                        <div class="item_title">{{ doc.question }}</div>
                                        <div class="item_desc">打开此文档</div>
                                    </div>
                                    <img @click="removeFast(doc.id)" class="remove_icon" src="./img/img_icon_10.png" alt="">
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div class="page_part">
                    <div class="part_header">
                        <div class="part_title"><img class="title_icon" src="./img/img_icon_01.png" alt="">最近文档</div>
                        <div class="part_right">
                            <div v-show="multipleSelection.length" class="title_btn remove_btn" @click="removeAll"><img class="btn_icon title_icon" src="./img/img_icon_68.png" alt="">删除文档</div>
                            <el-input size="small" class="search_input" placeholder="请输入关键字" suffix-icon="el-icon-search" v-model="searchVal" @keyup.enter.native="searchData"></el-input>
                        </div>
                    </div>
                    <div class="part_content">
                        <el-table class="doc_table" :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"  v-if="tableData">
                            <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                            <el-table-column label="文档名称" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <div class="doc_name" style="cursor: pointer;" v-if="scope.row.id==0" @click="showVideo">
                                        <span>
                                            <img class="table_icon" src="./img/img_icon_30.png" alt="">{{ scope.row.question }}
                                        </span>
                                        <img class="nav_icon" :src="require(scope.row.is_star?'./img/star.png':'./img/img_icon_02.png')">
                                    </div>
                                    <div class="doc_name" v-else>
                                        <router-link :to="'/longwriting?tplid='+scope.row.template_id+'&artid='+scope.row.id" v-if="scope.row.template_id ==27">
                                            <img class="table_icon" src="./img/img_icon_30.png" alt="">{{ scope.row.question }}
                                        </router-link>
                                        <router-link :to="'/essaywriting?tplid='+scope.row.template_id+'&artid='+scope.row.id" v-else>
                                            <img class="table_icon" src="./img/img_icon_30.png" alt="">{{ scope.row.question }}
                                        </router-link>
                                        <img class="nav_icon" @click="doActionRow(scope.row, 'star')" :src="require(scope.row.is_star?'./img/star.png':'./img/img_icon_02.png')">
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="model_type" label="应用模版" width="240">
                                <template slot-scope="scope">
                                    <img class="table_icon" :src="scope.row.app_icon" alt="">{{ scope.row.app_name }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="real_name" label="创作作者" width="150">
                                <template slot-scope="scope">
                                    <span style="color: #999;">{{ scope.row.real_name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="update_time" label="最近打开时间" width="200">
                                <template slot-scope="scope">
                                    <span style="color: #999;">{{ scope.row.update_time }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="40" align="right">
                                <template slot-scope="scope">
                                    <el-popover placement="left-start" :offset="10" width="280" trigger="click" @after-leave="popHide(scope.row)">
                                        <div class="more_menu" v-show="!scope.row.show&&total>0">
                                            <div class="menu_group">
                                                <div class="menu_item"><img class="menu_icon" src="./img/img_icon_70.png" alt=""><el-link :href="'/essaywriting?tplid='+scope.row.template_id+'&artid='+scope.row.id" target="_blank">在新标签页打开</el-link></div>
                                            </div>
                                            <div class="menu_group">
                                                <div class="menu_item" @click="doActionRow(scope.row, 'star')"><img class="menu_icon" src="./img/img_icon_02.png" alt="">{{ scope.row.is_star?"取消星标":"加入星标" }}</div>
                                                <div class="menu_item" @click="doActionRow(scope.row, 'rename')"><img class="menu_icon" src="./img/img_icon_71.png" alt="">重命名</div>
                                                <div class="menu_item" @click="doActionRow(scope.row, 'copy')"><img class="menu_icon" src="./img/img_icon_42.png" alt="">复制</div>
                                                <div v-if="scope.row.is_quick_access==0" class="menu_item" @click="doActionRow(scope.row, 'quickaccess')"><img class="menu_icon" src="./img/img_icon_72.png" alt="">添加到快捷访问</div>
                                                <div @click="scope.row.show=true" class="menu_item"><img class="menu_icon" src="./img/img_icon_29.png" alt="">导出<img class="menu_icon right_icon" src="./img/img_icon_32.png" alt=""></div>
                                                <div class="menu_item" @click="showShare(scope.row)"><img class="menu_icon" src="./img/img_icon_37.png" alt="">分享</div>
                                            </div>
                                            <div class="menu_group">
                                                <div class="menu_item" @click="doActionRow(scope.row, 'delete')"><img class="menu_icon" src="./img/img_icon_13.png" alt="">删除文档</div>
                                            </div>
                                        </div>
                                        <div class="more_menu" v-show="scope.row.show">
                                            <div class="menu_group">
                                                <div @click="scope.row.show=false" class="menu_item"><img class="menu_icon" src="./img/img_icon_73.png" alt="">返回</div>
                                            </div>
                                            <div class="menu_group" v-for=" item in exportTypeList" :key="item.type">
                                                <div class="menu_item" @click="fileExport(scope.row, item.type)"><img class="menu_icon" :src="require('./img/img_icon_'+item.icon+'.png')" alt="">导出{{ item.name }}</div>
                                            </div>
                                        </div>
                                        <img class="table_icon more_icon" slot="reference" src="./img/img_icon_69.png" alt="">
                                    </el-popover>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination_wrap" v-if="total">
                            <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :page-sizes=[10,15,50,100] :page-size="page_size" layout="prev, pager, next, sizes" prev-text="上一页" next-text="下一页" :current-page="page" :total="total"></el-pagination>
                        </div>
                        <div  v-if="total==0&&isLogin" class="kong">
                            <router-link active-class="active" exact class="nav_item" to="/essaywriting?tplid=19&m=a">
                                <img src="./img/kong.png">
                                <div class="write">无文档，去创作 →</div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <uploadDocVue ref="uploadDoc" @uploaded="upload"></uploadDocVue>
        <shareDoc ref="shareDoc"></shareDoc>
        <wordCharge ref="wordCharge"></wordCharge>
        <vipUpgrade @confirm="confirmVipUpgrade" v-show="vipUpgradeVisible"></vipUpgrade>
        <videoDialog ref="videoDialog"></videoDialog>
    </div>
</template>
<script type="text/ecmascript-6">
    
    import uploadDocVue from 'COMPONENTS/UploadDoc.vue';
    import shareDoc from 'COMPONENTS/ShareDoc.vue';
    import wordCharge from "COMPONENTS/WordCharge.vue";
    import vipUpgrade from "COMPONENTS/VipUpgrade.vue"
    import videoDialog from "COMPONENTS/VideoDialog.vue"
    export default {
        components:{uploadDocVue,shareDoc, wordCharge, vipUpgrade, videoDialog},
        data() {
            return {
                tableData:[
                    {
                        "add_time": "刚刚",
                        "app_icon": "https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/202309/12/20230912154405270847.png",
                        "app_name": "官方",
                        "id": 0,
                        "is_quick_access": 0,
                        "is_star": 0,
                        "question": "范文",
                        "real_name": "懒人办公",
                        "template_id": 18,
                        "update_time": "刚刚",
                        "user_id": 0
                    },
                    {
                        "add_time": "刚刚",
                        "app_icon": "https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/202309/12/20230912154405270847.png",
                        "app_name": "官方",
                        "id": 0,
                        "is_quick_access": 0,
                        "is_star": 0,
                        "question": "如何使用Ai写作",
                        "real_name": "懒人办公",
                        "template_id": 18,
                        "update_time": "刚刚",
                        "user_id": 0
                    }
                ],
                total:0,
                page_size:10,
                multipleSelection:[],
                searchVal:"",
                fast_list:[],
                exportTypeList:[
                    {name:"Word文档",type:"docx",icon:"29"},
                    // {name:"图片格式",type:"img",icon:"45"},
                    // {name:"PDF格式文档",type:"pdf",icon:"46"},
                    {name:"TXT文档",type:"txt",icon:"47"},
                    // {name:"MarkDown格式文档",type:"markdown",icon:"48"},
                ],
                page:1,
                token:"",
                titlePlaceholder:"",
                vipUpgradeVisible:false
            }
        },
        computed:{
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            }
        },
        created() {
            // 媒体ID
            localStorage.setItem("ad_account_id", this.$route.query.adaid || '');
            // 站点ID
            localStorage.setItem("site_id", this.$route.query.site_id || '');
            // 搜索关键词
            localStorage.setItem("keyword", this.$route.query.q || '');
            // 邀请码
            let invite_code = this.$route.query.invite_code || '';
            localStorage.setItem("invite_code", invite_code);
            // 百度广告参数
            localStorage.setItem("bd_vid", this.$route.query.bd_vid || '');
            // 360搜索推广参数
            localStorage.setItem("qhclickid", this.$route.query.qhclickid || '');
            // 360展示广告参数
            localStorage.setItem("sourceid", this.$route.query.sourceid || '');
            // 日期参数
            localStorage.setItem("timestamp", this.$route.query.timestamp || '');
            //判断url中是否带有token
            let resu = location.href.indexOf('token')
            if(resu > 0){
                let href = location.href
                let params = this.getUrlParams(href)
                href = href.replace("token="+params.token, "").replace("?&", "?")//.replace("?", "")
                location.href = href
            }

            let token = this.$route.query.token || '';
            if(token){
                localStorage.setItem("token", token);
            }

            this.token = token || localStorage.getItem("token")
            this.fetchArticleList()
            this.fetchQuickAccessList()
            // let show_video = localStorage.getItem("show_video") || 0
            // if(show_video==0){
            //     localStorage.setItem("show_video",1);
            //     this.$parent.showVideo()
            // }
        },
        
        methods: {
            getUrlParams(url) {
                // 通过 ? 分割获取后面的参数字符串
                let urlStr = url.split('?')[1]
                // 创建空对象存储参数
                let obj = {};
                // 再通过 & 将每一个参数单独分割出来
                let paramsArr = urlStr.split('&')
                for(let i = 0,len = paramsArr.length;i < len;i++){
                    // 再通过 = 将每一个参数分割为 key:value 的形式
                    let arr = paramsArr[i].split('=')
                    obj[arr[0]] = arr[1];
                }
                return obj
            },
            confirmVipUpgrade(val){
                this.vipUpgradeVisible = val.flag;
                if(val.action=="buy_words"){
                    this.$refs.wordCharge.show()
                }
            },
            showVideo(){
                this.$refs.videoDialog.show()
                // deferredPrompt.prompt()
            },
            showUpload(){
                this.$refs.uploadDoc.show();
            },
            showShare(row){
                this.$refs.shareDoc.show(row.id);
            },
            upload(data){
                this.$router.push(`/essaywriting?tplid=${data.template_id}&artid=${data.art_id}`)
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            searchData(){
                this.page = 1;
                this.fetchArticleList()
            },
            handlePageChange(val){
                this.page = val;
                this.fetchArticleList();
            },
            handleSizeChange(size){
                this.page_size = size;
                this.fetchArticleList()
            },
            fetchQuickAccessList(){
                // 快捷文档
                this.$http.get(`/front/aixz/article/quickaccess/`,{params:{page:1}}).then(res =>{
                    if(res.status=='200'){
                        this.fast_list = res.data.item_list
                    }
                })
            },
            fetchArticleList(){
                // 最近文档
                this.$http.get(`/front/aixz/article/`,{params:{page:this.page, question:this.searchVal, page_size:this.page_size}}).then(res =>{
                    if(res.status=='200'){
                        this.total =  res.data.total;
                        this.tableData = res.data.item_list.map(item=>{
                            item.show = false;
                            return item
                        })
                    }
                })
            },
            removeFast(id){
                this.$http.put(`/front/aixz/article/quickaccess/${id}/`,{is_quick_access:0}).then(res =>{
                    if(res.status=='200'){
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration:1500
                        });
                        this.fetchQuickAccessList()
                    }
                })
            },
            openDetail(doc){
                this.$router.push(`/essaywriting?tplid=${doc.template_id}&artid=${doc.id}`);
            },
            popHide(data){
                data.show =false;
            },
            doActionRow(row, action){
                // 单行操作
                let value
                if(action=="star"){
                    value = row.is_star ? 0:1
                    this.$http.patch(`/front/aixz/article/${row.id}/`,{action:action, value:value}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                            this.fetchArticleList()
                        }
                    })
                } else if(action=="delete"){
                    this.$confirm('此操作将该文档, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        this.$http.delete(`/front/aixz/article/${row.id}/`).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration:1500
                                });
                                this.fetchArticleList()
                            }
                        })
                    }).catch(() => {});
                } else if(action == "rename"){
                    this.$prompt('请输入文档标题', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPlaceholder: row.question
                        }).then(({ value }) => {
                            if(value){
                                row.question = value
                                this.$http.patch(`/front/aixz/article/${row.id}/`,{action:action, value:value}).then(res =>{
                                    if(res.status=='200'){
                                        this.$message({
                                            message: '操作成功',
                                            type: 'success',
                                            duration:1500
                                        });
                                    }
                                })
                            }
                        }).catch(() => {
                        });
                } else if(action == "quickaccess"){
                    this.$http.put(`/front/aixz/article/quickaccess/${row.id}/`,{is_quick_access:1}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                            row.is_quick_access = 1
                        }
                        this.fetchQuickAccessList()
                    }).catch(res => {
                        this.$message({
                            message: res.result,
                            type: 'warning',
                            duration:1500
                        });
                    })
                } else if(action == "copy"){
                    this.$http.patch(`/front/aixz/article/${row.id}/`,{action:action}).then(res =>{
                        if(res.status=='200'){
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration:1500
                            });
                        }
                        this.fetchArticleList()
                    })
                }
            },
            removeAll(){
                if(!this.multipleSelection.length){
                    this.$message({
                        message: '请先选择文档',
                        type: 'warning',
                        duration:1500
                    });
                }else{
                    this.$confirm('此操作将删除选中的文档, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'error'
                    }).then(() => {
                        let value = ""
                        this.multipleSelection.forEach(e => {
                            if(value==""){
                                value = e.id
                            }else{
                                value += "," + e.id
                            }
                        })
                        this.$http.patch(`/front/aixz/article/`,{action:"delete", value:value}).then(res =>{
                            if(res.status=='200'){
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration:1500
                                });
                                this.fetchArticleList()
                            }
                        })
                    }).catch(() => {});
                }
            },
            fileExport(item, action){
                if(this.userInfo.is_vip==1 && this.userInfo.vip_type>=1){
                    // 有权限
                }else{
                    this.vipUpgradeVisible = true
                    return
                }
                let t = Date.now()
                let downloadUrl = API_SERVER+'/api/front/aixz/article/export/?art_id='+item.id+"&action="+action + "&t="+t
                this.downloadExcel(downloadUrl, `${item.question}.${action}`);
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #recently{
        height: 100%;
        overflow: hidden;
        .page_wraper{
            padding: 20px;
            .page_banner{
                background-color: #eee;
                border-radius: 6px;
                padding: 6px 24px 0 32px;
                height: 240px;
                display: flex;
                .banner_text{
                    flex-grow: 1;
                    .title_text{
                        font-weight: bold;
                        font-size: 20px;
                        line-height: 46px;
                        padding-top: 10px;
                        .fast_speed{
                            width: 22px;
                            margin-left: 12px;
                            vertical-align: middle;
                            margin-top: -2px;
                        }
                    }
                    .slogin_text{
                        font-weight: bold;
                        font-size: 28px;
                        line-height: 52px;
                    }
                    .desc_text{
                        font-size: 14px;
                        color: #07c160;
                        line-height: 44px;
                        margin-bottom: 8px;
                    }
                    .banner_btns{
                        .banner_btn{
                            width: 160px;
                            height: 46px;
                            border: 1px solid #07c160;
                            line-height: 44px;
                            font-size: 14px;
                            color: #07c160;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            float: left;
                            background-color: #fff;
                            border-radius: 3px;
                            margin-right: 28px;
                            cursor: pointer;
                            &:first-child{
                                color: #fff;
                                background-color: #07c160;
                            }
                            .btn_icon{
                                width: 18px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
            .page_part{
                .part_header{
                    padding-top: 6px;
                    line-height: 54px;
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #e5e5e5;
                    &.no_border{
                        border-bottom: none;
                    }
                    .part_title{
                        flex-grow: 1;
                    }
                    .title_icon{
                        width: 16px;
                        margin: -2px 8px 0 -2px;
                        vertical-align: middle;
                    }
                    .btn_icon{
                        width: 16px;
                        margin: -2px 8px 0 0;
                    }
                    .part_right{
                        display: flex;
                        align-items: center;
                        .title_btn{
                            margin-right: 26px;
                            cursor: pointer;
                            &.remove_btn{
                                color: #cc0000;
                            }
                        }
                        .search_input{
                            width: 480px;
                        }
                    }
                }
                .part_content{
                    .fast_list{
                        .el-col-48{
                            width: 20%;
                        }
                        .list_item{
                            width: 100%;
                            border: 1px solid #e5e5e5;
                            background-color: #fff;
                            border-radius: 3px;
                            display: flex;
                            align-items: center;
                            padding: 0 16px;
                            position: relative;
                            height: 58px;
                            cursor: pointer;
                            &:hover{
                                .remove_icon{
                                    display: block;
                                }
                            }
                            .item_icon{
                                display: block;
                                width: 30px;
                                margin-right: 12px;
                            }
                            .item_right{
                                flex-grow: 1;
                                font-size: 12px;
                                line-height: 20px;
                                overflow: hidden;
                                .item_title{
                                    font-weight: bold;
                                }
                                .item_desc{
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    color: #999;
                                }
                            }
                            .remove_icon{
                                position: absolute;
                                display: none;
                                width: 18px;
                                top: 10px;
                                right: 10px;
                            }
                        }
                    }
                    .kong{
                        text-align: center;
                        cursor: pointer;
                        .write{color: #ccc;}
                        img{
                            height: 150px;
                        }
                    }
                    .doc_table{
                        background-color: transparent;
                        /deep/ tr{
                            background-color: transparent;
                            .el-table__cell{ 
                                padding: 17px 0;
                                border-color: #eee;
                                .cell{
                                    padding: 0;
                                }
                            }
                        }
                        .doc_name{
                            display: flex;
                            align-items: center;
                            &:hover{
                                .nav_icon{
                                    display: inline-block;
                                }
                            }
                            a{
                                overflow:hidden;
                                text-overflow:ellipsis;
                            }
                        }
                        .nav_icon{
                            width: 15px;
                            height: 15px;
                            margin-left: 5px;
                            cursor: pointer;
                            display: none;
                        }
                        .table_icon{
                            width: 16px;
                            margin-right: 8px;
                            vertical-align: middle;
                            margin-top: -2px;
                            &.more_icon{
                                margin-right: 4px;
                            }
                        }
                    }
                    .more_icon{
                        cursor: pointer;
                    }
                    .pagination_wrap{
                        text-align: center;
                        margin-top: 25px;
                    }
                }
            }
        }
    }
    .more_menu{
        padding: 0 15px;
        .menu_group{
            padding: 10px 0;
            border-bottom: 1px dashed #ccc;
            &:last-child{
                border-bottom: none;
            }
            .menu_item{
                line-height: 42px;
                cursor: pointer;
                position: relative;
                padding-left: 16px;
                &:hover{
                    background-color: #eee;
                }

                .menu_icon{
                    width: 16px;
                    vertical-align: middle;
                    margin: -2px 16px 0 0;
                }
                .right_icon{
                    width: 20px;
                    margin: 0;
                    position: absolute;
                    top: 11px;
                    right: -7px;
                }
            }
        }
    }
</style>